export default __webpack_public_path__ + "static/media/apple-icon.4e342371.svg";